import { createContext, useContext, useEffect, useState } from "react";

const THEME_KEY = "afc_theme"; // 'dark' | 'light'
const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    return localStorage.getItem(THEME_KEY) || "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    // v3.0 DS · light default, neon class kept for legacy overrides
    body.classList.add("theme-neon");
    root.classList.remove("theme-dark", "theme-light", "dark");
    if (theme === "dark") {
      root.classList.add("theme-dark", "dark");
    } else {
      root.classList.add("theme-light");
    }
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle, isDark: theme === "dark" }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) return { theme: "light", setTheme: () => {}, toggle: () => {}, isDark: false };
  return ctx;
}
